export function getLocaleDate(date, direction) {
  return direction === "rtl"
    ? date.locale("fa").format("jYYYY/jMM/jDD")
    : date.locale("en").format("YYYY/MM/DD");
}
